<mat-sidenav-container class="h-100">
    <mat-sidenav
        *ngIf="user$ | async as user"
        #sidenav
        [mode]="mediaQueryList.matches ? 'over' : 'side'"
        [opened]="navOpen$ | async"
    >
        <div class="sidenav-header d-flex">
            <div class="sidenav-header__logo">
                <a routerLink="/">
                    <img src="assets/eLight-white-logo.png" alt="eLight logo" />
                </a>
            </div>
            <div class="d-flex flex-grow-1"></div>
            <div class="d-flex flex-row align-items-center mt-4">
                <div class="sidenav-header__userinfo">
                    <span>{{ user.displayName }}</span>
                </div>
                <div class="sidenav-header__actions">
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="userMenu"
                        aria-label="menu"
                    >
                        <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #userMenu="matMenu">
                        <button mat-menu-item (click)="logout()">
                            <span>Logout</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
            <div
                class="d-flex flex-row align-items-center"
                style="height: 40px"
            >
                <div class="d-flex flex-grow-1">
                    {{ user.currentDivision?.name }}
                </div>
                <ng-container *ngIf="divisionChangeInProgress">
                    <div class="division_spinner_wrapper">
                        <mat-spinner [diameter]="16"></mat-spinner>
                    </div>
                </ng-container>
                <ng-container *ngIf="!divisionChangeInProgress">
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="changeDivisionMenu"
                        aria-label="Change Division"
                    >
                        <mat-icon>expand_more</mat-icon>
                    </button>
                    <mat-menu #changeDivisionMenu="matMenu">
                        <ng-container *ngFor="let division of user.divisions">
                            <button
                                [disabled]="
                                    division.id === user.currentDivision.id
                                "
                                (click)="changeDivision(division)"
                                mat-menu-item
                            >
                                <span>{{ division.name }}</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                </ng-container>
            </div>
        </div>

        <div class="sidenav-list px-2">
            <mat-nav-list>
                <ng-container *ngFor="let item of menu">
                    <ng-container *ngIf="!item.children?.length">
                        <a
                            *ngIf="makeOf(item.isVisible) | async"
                            class="app-sidenav-item"
                            mat-list-item
                            [routerLink]="item.route"
                            routerLinkActive="active-link"
                        >
                            <mat-icon fontSet="material-icons-outlined">{{
                                item.icon
                            }}</mat-icon>
                            <span class="pl-2">{{ item.title }}</span>
                        </a>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngIf="item.children?.length > 0">
                        <mat-accordion>
                            <mat-expansion-panel
                                class="mat-elevation-z"
                                [expanded]="item.isActive"
                            >
                                <mat-expansion-panel-header
                                    class="mat-menu-header"
                                >
                                    <mat-panel-title>
                                        <mat-icon
                                            fontSet="material-icons-outlined"
                                            >{{ item.icon }}</mat-icon
                                        >
                                        <span class="d-inline-block pl-2">{{
                                            item.title
                                        }}</span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-container
                                    *ngFor="let child of item.children"
                                >
                                    <a
                                        *ngIf="makeOf(child.isVisible) | async"
                                        class="app-sidenav-item pl-3"
                                        mat-list-item
                                        [routerLink]="child.route"
                                        routerLinkActive="active-link"
                                    >
                                        <span class="pl-3">{{
                                            child.title
                                        }}</span>
                                    </a>
                                </ng-container>
                            </mat-expansion-panel>
                        </mat-accordion>
                        <mat-divider></mat-divider>
                    </ng-container>
                </ng-container>
            </mat-nav-list>
        </div>

        <div class="sidenav-footer d-flex">
            <!-- sidenav footer placeholder -->
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
